/**
 * The public applicant registration pages (plan F3). `planning.register`, which also holds the 1A
 * map-register banner keys (pending, dead, lastError, retry, retried).
 * The accepted text is the same whatever the email: the page must never reveal whether it is known.
 */
export default {
  // The case page's map-register banner (1A) shares this root.
  pending: 'Map update pending.',
  dead: 'Map update failed.',
  lastError: 'Last error: {{error}}',
  retry: 'Retry map update',
  retried: 'The map update was queued again.',
  // Plan P4-1a D-411: "may", because the public form cannot read whether the tenant turned notifications on.
  emailNotice:
    'The council may email you updates about your application. You can turn them off under Email preferences once you have signed in.',
  shell: {
    language: 'Language',
    fallbackName: 'Planning permission',
  },
  form: {
    title: 'Register as an applicant',
    intro:
      'Consultants submit planning permission applications online. Send your details: an officer reviews them, and you receive sign-in details by email once approved.',
    email: 'Email',
    displayName: 'Full name',
    firm: 'Firm (optional)',
    regNo: 'Professional registration number (optional)',
    submit: 'Send registration',
    required: 'Required.',
    emailInvalid: 'Enter a valid email address.',
    tooLong: 'Too long: at most {{max}} characters.',
    haveCode: 'Already registered? Check your status',
    signIn: 'Already have an account? Sign in',
  },
  accepted: {
    title: 'Registration received',
    body: 'If your details can be accepted, an officer will review your request. You will receive sign-in details by email once it is approved.',
    codeLabel: 'Your status code',
    codeHint:
      'Keep this code: it is the only way to check your registration status, and it is not shown again once you leave this page.',
    copy: 'Copy code',
    copied: 'Copied',
  },
  status: {
    title: 'Registration status',
    intro: 'Paste the status code you received when you registered.',
    codeLabel: 'Status code',
    check: 'Check status',
    submittedAt: 'Requested on {{date}}',
    reason: 'Reason: {{reason}}',
    states: {
      submitted: 'Waiting for review',
      approved: 'Approved. Check your email for your sign-in details.',
      rejected: 'Not approved',
      superseded: 'Replaced by a newer registration with the same email',
      expired: 'Expired without a decision. You may register again.',
    },
    notFound: 'No registration matches this code. Check that you pasted all of it.',
    registerAgain: 'Register again',
  },
  errors: {
    closed: 'Applicant registration is not open for this organisation.',
    rateLimited: 'Too many attempts from your connection. Wait a few minutes and try again.',
    invalid: 'Some details are not valid. Check the highlighted fields.',
    network: 'Could not reach the server. Check your connection and try again.',
    generic: 'Something went wrong. Try again.',
  },
} as const
